import React, { useState, useEffect } from 'react';
import './WeddingPage.css';
import { Heart, Sparkles, Wine, Music, Coffee, Users, PartyPopper } from 'lucide-react';

// Wedding App - Correct Order Version
function WeddingApp() {
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0 });
  const [activeFaq, setActiveFaq] = useState(null);

  useEffect(() => {
    console.log('=== WEDDING APP - CORRECT ORDER VERSION ===');
    const updateCountdown = () => {
      const weddingDate = new Date('2026-08-29T14:00:00').getTime();
      const now = new Date().getTime();
      const distance = weddingDate - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

      setCountdown({ days, hours, minutes });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 60000);
    return () => clearInterval(interval);
  }, []);

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offsetTop = element.offsetTop - 80;
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  };

  const faqData = [
    {
      question: "Est-ce que je peux planter une tente ?",
      answer: "Oui ! Possibilité de planter des tentes sur place pour ceux qui le souhaitent."
    },
    {
      question: "Les enfants sont-ils admis ?",
      answer: "Pour ce grand jour, on célèbre l'amour entre adultes, mais on vous réserve plein de récits à raconter aux enfants pour qu'ils ne soient pas jaloux !"
    },
    {
      question: "Maillot de bain ?",
      answer: "Oui, pensez à prendre votre maillot de bain pour le dimanche !"
    }
  ];

  const timelineData = [
    {
      date: "Juillet 2018",
      text: "Rencontre en juillet 2018 juste après la victoire de la France à la coupe du monde, sur notre lieu de travail, comme c'est original.",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/zulnxpcy_nos%201%20an.jpg"
    },
    {
      date: "Juillet 2019",
      text: "C'est le moment d'officialiser notre relation.",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/rffoxbr8_Visite%20Paris.jpg"
    },
    {
      date: "Juillet 2020",
      text: "On commence à emménager ensemble à Pantin (post Covid).",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/x5vw1pii_IMG_20210504_181644_590.jpg"
    },
    {
      date: "Septembre 2021",
      text: "Voyage en Grèce, découverte de nouveaux horizons ensemble.",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/b2yagn8e_20210918_185607.jpg"
    },
    {
      date: "Juillet 2022",
      text: "On est tirés au sort pour aller au Canada. Arrivée à Montréal !",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/h9fv6wap_20230916_185650.jpg"
    },
    {
      date: "Septembre 2024",
      text: "Arrivée d'Oscar - la famille s'agrandit !",
      image: "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/y97f8ja3_20240916_095042.jpg"
    },
    {
      date: "Juillet 2025",
      text: "L'heure de la demande pour sceller notre amour.",
      image: "https://customer-assets.emergentagent.com/job_56f18461-41a0-40e7-b07e-61b6d16ffbd7/artifacts/d7whi6rx_demande%20mariage.JPG"
    }
  ];

  const galleryImages = [
    "https://customer-assets.emergentagent.com/job_56f18461-41a0-40e7-b07e-61b6d16ffbd7/artifacts/327qofv2_20240330_120737.jpg",
    "https://customer-assets.emergentagent.com/job_56f18461-41a0-40e7-b07e-61b6d16ffbd7/artifacts/u3sud8kr_Le%20conducteur%20fou%20en%20grece.jpg",
    "https://customer-assets.emergentagent.com/job_56f18461-41a0-40e7-b07e-61b6d16ffbd7/artifacts/d7whi6rx_demande%20mariage.JPG",
    "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/kuk5j3bc_Piliers%20de%20bar.JPG",
    "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/zulnxpcy_nos%201%20an.jpg",
    "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/rffoxbr8_Visite%20Paris.jpg",
    "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/vphilxtg_Venezia.jpg",
    "https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/kx89vfdv_1ere%20fois%20a%20angers.jpg"
  ];

  const accommodations = [
    {
      name: "La Grande Vieillière",
      capacity: "12 couchages",
      description: "Gîte spacieux idéal pour les familles",
      link: "https://www.gites-de-france.com/fr/pays-de-la-loire/sarthe/la-grande-vieilliere-h72h022452?adults=2&children=0&infants=0"
    },
    {
      name: "Villa du Loir",
      capacity: "5 couchages (3+2)",
      description: "Villa confortable au bord du Loir",
      link: "https://www.gites-de-france.com/fr/pays-de-la-loire/sarthe/villa-du-loir-h72h025839?from=2026-08-29&to=2026-08-30&on_demand=0#rooms"
    },
    {
      name: "Chambres Familiales",
      capacity: "10 couchages (4+4+2)",
      description: "Chambres Armand, Raphaël et Agathe",
      link: "https://www.gites-de-france.com/fr/pays-de-la-loire/sarthe/chambres-familiales-armand-raphael-et-chambre-double-agathe-h72h024326?from=2026-08-29&to=2026-08-30&on_demand=0#rooms"
    },
    {
      name: "La Girouardière",
      capacity: "10 couchages (2+2+2+2+2)",
      description: "Plusieurs chambres indépendantes",
      link: "https://www.gites-de-france.com/fr/pays-de-la-loire/sarthe/la-girouardiere-h72h031576?from=2026-08-29&to=2026-08-30&on_demand=0#rooms"
    }
  ];

  const programItems = [
    { time: "13h30", title: "Accueil des invités", description: "Nous vous attendons pour nous accompagner", icon: Users },
    { time: "14h00", title: "Cérémonie Laïque", description: "Lorsque nous nous dirons oui", icon: Heart },
    { time: "15h00", title: "Vin d'honneur & Réception", description: "Partagez ce moment avec nous", icon: Sparkles },
    { time: "19h00", title: "Dîner", description: "Simple, généreux, délicieux", icon: Wine },
    { time: "Soirée", title: "La Fiesta", description: "On compte sur vous jusqu'au bout de la nuit !", icon: Music },
    { time: "10h30", title: "Prolongation", description: "RDV le lendemain pour prolonger ces instants de bonheur", icon: Coffee }
  ];

  return (
    <div className="wedding-page">
      {/* Navigation */}
      <nav className="wedding-nav">
        <ul>
          <li><a href="#accueil" onClick={(e) => scrollToSection(e, 'accueil')}>Accueil</a></li>
          <li><a href="#jourj" onClick={(e) => scrollToSection(e, 'jourj')}>Le Jour J</a></li>
          <li><a href="#infos" onClick={(e) => scrollToSection(e, 'infos')}>Infos Pratiques</a></li>
          <li><a href="#faq" onClick={(e) => scrollToSection(e, 'faq')}>FAQ</a></li>
          <li><a href="#histoire" onClick={(e) => scrollToSection(e, 'histoire')}>Notre Histoire</a></li>
          <li><a href="#galerie" onClick={(e) => scrollToSection(e, 'galerie')}>Galerie</a></li>
        </ul>
      </nav>

      {/* Hero Section avec Compte à rebours */}
      <section id="accueil" className="hero">
        <div className="hero-content">
          <p className="script-text">Célébrazione & Amore</p>
          <h1>Clélia & Romain</h1>
          <p className="date-display">29 Août 2026</p>
          
          <div className="countdown">
            <div className="countdown-item">
              <span className="countdown-number">{countdown.days}</span>
              <span className="countdown-label">Jours</span>
            </div>
            <div className="countdown-item">
              <span className="countdown-number">{countdown.hours}</span>
              <span className="countdown-label">Heures</span>
            </div>
            <div className="countdown-item">
              <span className="countdown-number">{countdown.minutes}</span>
              <span className="countdown-label">Minutes</span>
            </div>
          </div>

          <a href="#jourj" className="btn" onClick={(e) => scrollToSection(e, 'jourj')}>Voir le programme</a>
        </div>
      </section>

      <div className="leaf-separator">❤️ ✦ ❤️</div>

      {/* Le Jour J */}
      <section id="jourj">
        <div className="container">
          <div className="section-header">
            <h2>Le grand jour</h2>
            <div className="divider"></div>
            <p className="script-text">Al Haras de la Potardière</p>
          </div>

          <div className="location-info">
            <h3>Haras de la Potardière</h3>
            <p>Route De Bazouges<br />72200 Crosmières</p>
            <a href="https://www.google.com/maps/search/?api=1&query=Route+De+Bazouges,+72200+Crosmières" target="_blank" rel="noopener noreferrer" className="map-link">
              📍 Voir sur Google Maps
            </a>
            
            {/* Photos du Haras */}
            <div className="haras-photos">
              <img src="https://customer-assets.emergentagent.com/job_amoreetfiesta/artifacts/ctbia103_bonne-qualite-photo-ferme_3_315338-169157161839376.jpeg" alt="Haras de la Potardière" />
            </div>
          </div>

          <div className="day-program">
            <div className="program-list">
              {programItems.map((item, index) => {
                const IconComponent = item.icon;
                return (
                  <div key={index} className="program-item">
                    <div className="program-icon">
                      <IconComponent size={32} strokeWidth={1.5} />
                    </div>
                    <div className="program-time">{item.time}</div>
                    <div className="program-details">
                      <h4>{item.title}</h4>
                      <p>{item.description}</p>
                      {item.note && <p className="program-note">{item.note}</p>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <div className="leaf-separator">💐 ✦ 💐</div>

      {/* Infos Pratiques */}
      <section id="infos">
        <div className="container">
          <div className="section-header">
            <h2>Infos pratiques</h2>
            <div className="divider"></div>
          </div>

          {/* Hébergement */}
          <h3 style={{ textAlign: 'center', marginBottom: '2rem' }}>🏡 Hébergement</h3>
          <div className="cards-grid">
            {accommodations.map((accommodation, index) => (
              <div key={index} className="card">
                <h4>{accommodation.name}</h4>
                <span className="card-capacity">{accommodation.capacity}</span>
                <p style={{ margin: '1rem 0' }}>{accommodation.description}</p>
                <a href={accommodation.link} target="_blank" rel="noopener noreferrer">Réserver →</a>
              </div>
            ))}
          </div>

          <div className="info-box" style={{ textAlign: 'center', marginTop: '2rem' }}>
            <p>⛺ <strong>Camping :</strong> Possibilité de planter des tentes sur place pour ceux qui le souhaitent</p>
          </div>

          <div style={{ marginTop: '4rem' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '2rem' }}>🚗 Transports & Détails</h3>
            
            <div className="info-box">
              <h4>🚙 Transports</h4>
              <p>• Covoiturage possible depuis Paris (groupe Facebook à venir)</p>
              <p>• Parking facile et gratuit sur place</p>
            </div>

            <div className="info-box">
              <h4>👗 Dress Code</h4>
              <p>Soyez Belles et Beaux, pas de dress code imposé ! Venez comme vous vous sentez élégants et à l'aise.</p>
            </div>

            <div className="info-box highlight">
              <h4>🎁 Cadeaux</h4>
              <p>Votre présence est notre plus beau cadeau !</p>
              <p style={{ marginTop: '1rem' }}>Si vous souhaitez contribuer à notre voyage de noces :</p>
              <a href="https://www.leetchi.com/fr/c/mariage-clelia-et-romain-1990866" target="_blank" rel="noopener noreferrer" className="btn btn-secondary" style={{ marginTop: '1rem' }}>Participer à la cagnotte</a>
            </div>

            <div className="info-box">
              <h4>📸 Album Photos</h4>
              <p>Partagez vos meilleurs souvenirs de la journée !</p>
              <p style={{ marginTop: '0.5rem' }}><strong>Code album :</strong> FR3c329508</p>
              <p style={{ marginTop: '0.5rem', fontSize: '0.875rem', color: '#777' }}>Scannez le QR code sur place ou utilisez l'application dédiée</p>
            </div>

            <div className="info-box" style={{ textAlign: 'center' }}>
              <p>📅 <strong>Merci de confirmer votre présence avant le 26 mars 2026</strong></p>
            </div>
          </div>
        </div>
      </section>

      <div className="leaf-separator">✨ ✦ ✨</div>

      {/* FAQ */}
      <section id="faq">
        <div className="container">
          <div className="section-header">
            <h2>Questions Fréquentes</h2>
            <div className="divider"></div>
          </div>

          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            {faqData.map((faq, index) => (
              <div key={index} className={`faq-item ${activeFaq === index ? 'active' : ''}`}>
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  <span className="faq-icon">+</span>
                </button>
                <div className="faq-answer">
                  <p dangerouslySetInnerHTML={{ __html: faq.answer }}></p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="leaf-separator">🍷 ✦ 🍷</div>

      {/* Notre Histoire */}
      <section id="histoire">
        <div className="container">
          <div className="section-header">
            <h2>Notre Histoire</h2>
            <div className="divider"></div>
            <p className="script-text">Un voyage d'amour</p>
          </div>

          <div className="timeline">
            {timelineData.map((item, index) => (
              <div key={index} className={`timeline-item ${index % 2 === 0 ? 'left' : 'right'}`}>
                <div className="timeline-content">
                  <div className="timeline-date">{item.date}</div>
                  <p>{item.text}</p>
                </div>
                <div className="timeline-dot"></div>
                <img src={item.image} alt={item.date} className="timeline-image" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="leaf-separator">🪩 ✦ 🪩</div>

      {/* Galerie */}
      <section id="galerie">
        <div className="container">
          <div className="section-header">
            <h2>Notre Galerie</h2>
            <div className="divider"></div>
            <p className="script-text">Nos plus beaux moments</p>
          </div>

          <div className="gallery">
            {galleryImages.map((image, index) => (
              <div key={index} className="gallery-item">
                <img src={image} alt={`Photo ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer>
        <p>Merci à vous d'être présent pour ce moment si important pour nous deux.</p>
        <p className="script-text">Grazie & Amore</p>
        <p style={{ marginTop: '2rem', fontSize: '0.875rem' }}>Clélia & Romain • 29 Août 2026</p>
      </footer>
    </div>
  );
}

export default WeddingApp;
